export const NON_ORDER_MESSAGING_DISABLED_CODE = 'non-order-messaging-disabled';
export const NON_ORDER_MESSAGING_DISABLED_MESSAGE =
  'This conversation is unavailable from this view.';

const ORDER_MESSAGE_TABS = ['order', 'orders', 'all'];

export const isOrderMessagesTab = tab => ORDER_MESSAGE_TABS.includes(tab);

export const createBlockedNonOrderMessagingError = () => {
  const error = new Error(NON_ORDER_MESSAGING_DISABLED_MESSAGE);
  error.code = NON_ORDER_MESSAGING_DISABLED_CODE;
  error.status = 403;
  error.statusCode = 403;
  return error;
};
